import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_ClinicalForm } from '@app/hcs-shared';
export const dispatch_onClinicalFormsUpdated = new ThunderDispatcherV3('__onClinicalFormsUpdated');
export class ModuleFE_ClinicalForm_Class extends ModuleFE_BaseApi {
    constructor() {
        super(DBDef_ClinicalForm, dispatch_onClinicalFormsUpdated);
    }
}
export const ModuleFE_ClinicalForm = new ModuleFE_ClinicalForm_Class();
//# sourceMappingURL=ModuleFE_ClinicalForm.js.map